"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_slick_1 = require("react-slick");
function TestinalsSlider(props) {
    const settings = {
        draggable: true,
        autoplay: true,
        autoplaySpeed: 7000,
        arrows: false,
        dots: false,
        fade: true,
        speed: 500,
        infinite: true,
        cssEase: 'ease-in-out',
        touchThreshold: 100,
    };
    let slider = null;
    return (React.createElement("div", { className: 'col-sm-6 col-md-6 subpage-block' },
        React.createElement("div", { className: 'block-title' },
            React.createElement("h3", null, "Testimonials")),
        React.createElement("div", { className: 'testimonials owl-carousel owl-loaded owl-drag' },
            React.createElement("div", { className: 'owl-stage-outer' },
                React.createElement(react_slick_1.default, Object.assign({ ref: c => (slider = c) }, settings, { style: {
                        //transform: 'translate3d(-616px, 0px, 0px)',
                        transition: 'all 0s ease 0s',
                        width: '1848px'
                    } }), props.testimonials.map((testimonial) => {
                    return (React.createElement("div", { key: testimonial._id, className: 'owl-item cloned', style: { width: '298px', marginRight: '10px' } },
                        React.createElement("div", { className: 'testimonial-item' },
                            React.createElement("div", { className: 'testimonial-content' },
                                React.createElement("div", { className: 'testimonial-text' },
                                    React.createElement("p", null, testimonial.text))),
                            React.createElement("div", { className: 'testimonial-credits' },
                                React.createElement("div", { className: 'testimonial-picture' },
                                    React.createElement("img", { src: testimonial.picUrl || 'images/testi monials/testimonial_photo_1.png', alt: '' })),
                                React.createElement("div", { className: 'testimonial-author-info' },
                                    React.createElement("p", { className: 'testimonial-author' }, testimonial.author),
                                    testimonial.authorCompany &&
                                        React.createElement("p", { className: 'testimonial-firm' }, testimonial.authorCompany))))));
                }))),
            React.createElement("div", { className: 'owl-nav' },
                React.createElement("div", { onClick: (e) => slider.slickPrev(), className: 'owl-prev' }),
                React.createElement("div", { onClick: (e) => slider.slickNext(), className: 'owl-next' })))));
}
exports.default = TestinalsSlider;
